import { imageUrl } from '@helpers/image';
import { withMotion } from '@hoc/withMotion';
import PhoneIcon from '@img/icons/phone.svg';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './HeaderReduced.styles';
const HeaderReduced = (props) => {
    if (!props.logo) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, null,
            React.createElement(S.Inner, null,
                React.createElement(S.LogoWrapper, { href: "/" },
                    React.createElement(S.Logo, { src: imageUrl(props.logo, { height: 52, rmode: 'pad' }), alt: props.logo.altText, loading: "eager" })),
                React.createElement(S.ActionWrapper, null, props.telephone && (React.createElement(LinkButton, { buttonType: "default", href: `tel:${props.telephone.url}`, icon: React.createElement(PhoneIcon, null), iconPosition: "left", "data-prefix": props.telephone.prefix }, props.telephone.text)))))));
};
export default withMotion(HeaderReduced);
